import useLocalize from '../../../utils/hooks/useLocalize';

const BAR_SIZES = [
  { value: '5min', labelKey: 'symbol.details.historical.bar.size.5min' },
  { value: '1hour', labelKey: 'symbol.details.historical.bar.size.1hour' },
  { value: '1day', labelKey: 'symbol.details.historical.bar.size.day' },
  { value: '1week', labelKey: 'symbol.details.historical.bar.size.week' },
  { value: '1month', labelKey: 'symbol.details.historical.bar.size.month' },
  { value: '1quarter', labelKey: 'symbol.details.historical.bar.size.quarter' }
];

const BarSizeSelector = ({ barSize, onBarSizeChange, bars }) => {
  const localize = useLocalize();

  // Calculate highest and lowest prices in the period
  const highest =
    bars && bars.length > 0
      ? (() => {
          const validPrices = bars
            .map((bar) => bar.HighPrice)
            .filter((price) => price !== null && price !== undefined);
          return validPrices.length > 0 ? Math.max(...validPrices) : null;
        })()
      : null;
  const lowest =
    bars && bars.length > 0
      ? (() => {
          const validPrices = bars
            .map((bar) => bar.LowPrice)
            .filter((price) => price !== null && price !== undefined);
          return validPrices.length > 0 ? Math.min(...validPrices) : null;
        })()
      : null;

  return (
    <div className="bar-size-selector">
      <div className="bar-size-selector-left">
        <span className="bar-size-selector-label">
          {localize('symbol.details.historical.time.select')}
        </span>
        <div className="bar-size-buttons">
          {BAR_SIZES.map((size) => (
            <button
              key={size.value}
              className={`bar-size-button${
                barSize === size.value ? ' active' : ''
              }`}
              onClick={() => onBarSizeChange(size.value)}
            >
              {localize(size.labelKey)}
            </button>
          ))}
        </div>
      </div>
      {highest !== null && lowest !== null && (
        <div className="bar-size-selector-right">
          <div className="period-indicator period-high">
            <span className="period-indicator-box"></span>
            <span className="period-indicator-label">
              {localize('symbol.details.historical.label.highest')}
            </span>
          </div>
          <div className="period-indicator period-low">
            <span className="period-indicator-box"></span>
            <span className="period-indicator-label">
              {localize('symbol.details.historical.label.lowest')}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default BarSizeSelector;
